import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";

import { BaseSearchController } from "../_baseSearchController";
import { LocalCacheService } from "../../services/local-cache-service";
import { NotifyService } from "../../services/notify-service";
import { EntityService } from "../../services/entity-service";
import { AssetService } from "../../services/asset-service";
import { WorkflowService } from "../../services/workflow-service";
import { SearchService } from "../../services/search-service";

export class AssetSearchController extends BaseSearchController<Models.IEntitySearchDoc>{

	static $inject = ["$scope", "$location", "$filter", "$window", "localCacheService", "notifyService", "entityService", "assetService", "workflowService", "$q"];

	selectedAssetIDs: number[];
	selectedAssetTitles: string[];

	//Bulk Association
	refreshList: boolean;
	//--

	constructor(
		$scope: ng.IScope,
		$location: ng.ILocationService,
		private $filter: ng.IFilterService,
		private $window: ng.IWindowService,
		localStorage: LocalCacheService,
		notifyService: NotifyService,
		entityService: EntityService,
		private assetService: AssetService,
		private workflowService: WorkflowService,
		$q: ng.IQService,
		searchService: SearchService) {

		super($scope, $q, $location, $filter, localStorage, notifyService, entityService, searchService);

		this.charTypeId = Consts.CharTypeIDs.property;

		this.selectedAssetIDs = [];
		this.selectedAssetTitles = [];
		this.relatedToMe = false;

		this.sortField = "title_sort";
		this.sortDir = 0;

		//Bulk Association
		this.refreshList = false;
		//--

		$scope.$watch(() => this.selectedItems, (newValue: { [key: string]: boolean }) => {
			this.selectedAssetIDs = _(newValue)
				.pairs()
				.filter((el) => el[1] === true)
				.map((el: [string, boolean]) => _.parseInt(el[0].split("|")[0]))
				.valueOf();

			this.selectedAssetTitles = _(newValue)
				.pairs()
				.filter((el) => el[1] === true)
				.map<string>((el: [string, boolean]) => el[0].split("|")[1])
				.valueOf();
		}, true);

		$scope.$watchCollection(() => [this.selectedStatus, this.selectedTemplate], (newValue) => {
			if (newValue[0] && newValue[1]) {
				this.workflowService.getAvailableWorkflowActions(Consts.CharTypeIDs.property, this.templateID, this.statusID)
					.then((res) => {
						this.workflowActions = _.map(res, (action) => {
							return {
								key: action.actionName,
								value: action.actionID
							}
						});
					});
			} else {
				this.workflowActions = [];
			}
		});

		$scope.$watch(() => this.refreshList, (newValue, oldValue) => {
			if (newValue != oldValue && newValue) {
				//Refresh the list to show any actions that were done
				this.selectedItems = {};
				this.search = true;
				this.refreshList = false;
			}
		}, true);		
	}

	// is a	non-empty workflow action selected
	HasWorkflowAction() {
		return !_.isNaN(_.parseInt(this.selectedAction));
	}

	AllCheckChanged() {
		_.forEach(this.itemRows, (itemRow) => {
			this.selectedItems[itemRow.recordID + "|" + itemRow.title] = this.allChecked;
		});
	}

	// execute a workflow task on the selected assets
	RunWorkflow() {
		// if there	is a selected action and assets	selected
		if (this.HasWorkflowAction() && this.selectedAssetIDs.length > 0) {
			// join	the	titles for a confirmation window
			var titles = this.selectedAssetTitles.join(",\n");
			if (this.$window.confirm("Are you sure you want to execute workflow on: \n" + titles)) {
				// execute workflow
				this.notifyService.startProgress();
				var promises = [];

				this.workflowService.createBatchID()
					.then((batchIDResult) => {
						var charTypeID = Consts.CharTypeIDs.property;
						var actionID = _.parseInt(this.selectedAction);

						this.workflowService.getAvailableWorkflowActions(charTypeID, this.templateID, this.statusID)
							.then((results) => {
								var actions = results;
								var processID = _.find(actions, (a) => { return a.actionID == actionID; }).processID;

								_.each(this.selectedAssetIDs, (c) => {
									promises.push(this.ExecuteWorkflow(batchIDResult.batchID, charTypeID, c, actionID, processID, this.statusID));
								});

								this.$q.all(promises)
									.then(() => {
										//Passing in 0 as the recID as this is not needed to process the notifications from a queue.  It really is just for logging.
										//To call this method from a loop statement would process a queue multiple times, which results in duplicate emails.
										//We only need to call this once when the queue has been fully populated
										this.workflowService.sendNotificationsFromQueue(charTypeID, 0, batchIDResult.batchID)
											.then((sentResult) => {
											}, () => {
												this.notifyService.notifyError("There was an error executing your workflow action.");
											});
									})
									.then(() => {
										this.notifyService.notifySuccess("Workflow action successful!");
									}, () => {
										this.notifyService.notifySuccess("Workflow action could not be completed");
									})
									.finally(() => {
										//this.selectedItems = {};
										//this.search = true;
										this.RunSearch();
										this.notifyService.endProgress();
									});
							});
					});
			}
		} else {
			this.notifyService.notifySuccess("Please select a workflow action and select assets from the search results");
		}
	}

	ExecuteWorkflow(batchID: string, charTypeID: number, recordID: number, actionID: number, processID: number, statusID: number): ng.IPromise<any> {
		return this.workflowService.addNotificationsToQueue(charTypeID, recordID, actionID, batchID, processID)
			.then((result) => {
				return this.workflowService.runPreProcess(charTypeID, processID, actionID, recordID, statusID)
					.then(() => {
						return this.workflowService.workflowUpdateEntityStatus(charTypeID, processID, actionID, recordID, statusID)
							.then((result) => {
								if (result.statusID > 0) {
									var newStatusID = result.statusID;
									return this.workflowService.runPostProcess(charTypeID, processID, actionID, recordID, statusID)
										.then(() => {
										}, () => {
											this.notifyService.notifyError("There was an error executing your workflow action.");
										});
								}
								else {
									this.notifyService.notifyError("There was an error executing your workflow action.");
								}
							}, () => {
								this.notifyService.notifyError("There was an error executing your workflow action.");
							});
					}, () => {
						this.notifyService.notifyError("There was an error executing your workflow action.");
					});

			}, () => {
				this.notifyService.notifyError("There was an error executing your workflow action.");
			});
	}

	Init() {
		//this.Initialize();
		//this.initialized = true;
	}	
}